import {useState} from 'react'

import Box from '@mui/material/Box'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Tooltip from '@mui/material/Tooltip'

const CopyToClipboard = props => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    if (!copied) {
      window.navigator.clipboard.writeText(props.text).then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
      }).catch(err => {
        if (__DEV__)
          console.error(err)
      })
    }
  }

  return (
    <Paper
      elevation={0}
      component='div'
      sx={{
        height: props.height || '40px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        bgcolor: '#F7F7F7',
        borderRadius: 'none',
        wordBreak: 'break-word'
      }}
      className='copy-to-clipboard'>
      <Box sx={{p: '8px'}}>{props.text}</Box>
      <Tooltip title={copied ? 'Copied' : 'Select to copy'}>
        <IconButton sx={{height: '41px'}} onClick={handleCopy}>
          <ContentCopyIcon fontSize='small' />
        </IconButton>
      </Tooltip>
    </Paper>
  )
}

export default CopyToClipboard
